module.exports = __webpack_public_path__ + "img/ref-2.aa750f0c.jpg";